<script setup>
import ToastNotification from "./components/ToastNotification.vue";
import NotificationModal from "./components/NotificationModal.vue";
</script>

<template>
  <div class="wrapper bg-gray">
    <router-view />
    <ToastNotification />
    <NotificationModal />
  </div>
</template>

<style>
@import "datatables.net-bs5";
@import "datatables.net-buttons-bs5";
@import "datatables.net-select-bs5";
</style>
